import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/keep-in-touch/page.jsx");
